var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/lib/PageHeader.tsx
import { Divider } from "@availity/mui-divider";
import { Typography } from "@availity/mui-typography";
import { Breadcrumbs } from "@availity/mui-breadcrumbs";
import { Link } from "@availity/mui-link";
import { Button } from "@availity/mui-button";
import { Feedback } from "@availity/mui-feedback";
import { Box, Grid } from "@availity/mui-layout";
import { SpacesImage } from "@availity/mui-spaces";
import Skeleton from "@mui/material/Skeleton";
import { jsx, jsxs } from "react/jsx-runtime";
var Logo = (props) => {
  if (props.spaceId)
    return /* @__PURE__ */ jsx(
      SpacesImage,
      {
        imageType: "images.logo",
        spaceId: props.spaceId,
        Loader: ({ id }) => /* @__PURE__ */ jsx(Skeleton, { id, height: "60px", width: "234px" })
      }
    );
  else if (props.payerId)
    return /* @__PURE__ */ jsx(
      SpacesImage,
      {
        imageType: "images.logo",
        payerId: props.payerId,
        Loader: ({ id }) => /* @__PURE__ */ jsx(Skeleton, { id, height: "60px", width: "234px" })
      }
    );
  else return null;
};
var PageHeader = ({
  breadcrumbs,
  buttons,
  feedback = false,
  headerText,
  logo,
  help
}) => {
  return /* @__PURE__ */ jsxs(
    Grid,
    {
      component: Box,
      container: true,
      direction: "column",
      sx: {
        marginTop: "1rem",
        marginBottom: "1.25rem",
        paddingLeft: 3,
        paddingRight: 3
      },
      children: [
        breadcrumbs || logo || help ? /* @__PURE__ */ jsxs(Grid, { direction: "row", container: true, sx: { justifyContent: "space-between", marginBottom: 4 }, spacing: 2, children: [
          breadcrumbs ? /* @__PURE__ */ jsx(Grid, { children: /* @__PURE__ */ jsx(Breadcrumbs, __spreadValues({}, breadcrumbs)) }) : /* @__PURE__ */ jsx(Grid, { sx: { display: { xs: "none", sm: "block" } } }),
          (logo || help) && /* @__PURE__ */ jsxs(Grid, { direction: "column", container: true, spacing: 2, children: [
            help && /* @__PURE__ */ jsx(Grid, { children: /* @__PURE__ */ jsxs(Typography, { variant: "body1", children: [
              "Need help?",
              " ",
              /* @__PURE__ */ jsx(Link, { href: help.url, target: "_blank", loadApp: false, children: help.helpAppName ? "Watch a demo" : "Learn More" }),
              " ",
              help.helpAppName ? ` for ${help.helpAppName}` : null
            ] }) }),
            logo && /* @__PURE__ */ jsx(Grid, { container: true, justifyContent: "end", children: /* @__PURE__ */ jsx(Logo, __spreadValues({}, logo)) })
          ] })
        ] }) : null,
        /* @__PURE__ */ jsxs(Grid, { direction: "row", container: true, sx: { marginBottom: 2, alignItems: "center", justifyContent: "space-between" }, children: [
          /* @__PURE__ */ jsx(Grid, { children: /* @__PURE__ */ jsx(Typography, { variant: "h1", children: headerText }) }),
          /* @__PURE__ */ jsxs(Grid, { container: true, sx: { width: "auto" }, children: [
            buttons && buttons.length > 0 && (buttons == null ? void 0 : buttons.map((_a) => {
              var _b = _a, { key } = _b, buttonProps = __objRest(_b, ["key"]);
              return /* @__PURE__ */ jsx(Grid, { marginLeft: 2, height: "100%", children: /* @__PURE__ */ jsx(Button, __spreadProps(__spreadValues({}, buttonProps), { size: "large", color: "secondary" })) }, key);
            })),
            feedback ? /* @__PURE__ */ jsx(Grid, { sx: { marginLeft: 2, height: "100%" }, children: /* @__PURE__ */ jsx(Feedback, { appName: headerText }) }) : null
          ] })
        ] }),
        /* @__PURE__ */ jsx(Divider, {})
      ]
    }
  );
};
export {
  PageHeader
};
